/**
 * `/` — Admin launchpad. The home page of q.postopia.com.
 *
 * Quiet grid of feature doorways. Mail is the only one live today;
 * Users / Flags / Audit / Settings render as greyed-out "coming soon"
 * tiles so the roadmap stays visible.
 *
 * Opening a feature (e.g. clicking the Mail tile) navigates to
 * `/mail` — a full-page experience with its own canvas. Returning
 * here is a "← Admin" link in that feature's top bar.
 */

import { createFileRoute } from '@tanstack/react-router';
import { AdminShell } from '../components/AdminShell';
import { AdminHome } from '../components/AdminHome';

export const Route = createFileRoute('/')({
  component: HomePage,
});

function HomePage() {
  return (
    <AdminShell mode="home">
      <AdminHome />
    </AdminShell>
  );
}
